import {
  Component,
  Input,
  OnInit,
  ChangeDetectionStrategy,
} from '@angular/core';
import { BaseTimingViewmodel } from 'edu-application/dist/timings/base/timings.viewmodel';

@Component({
  selector: 'edu-admin-timings',
  templateUrl: './admin-timings.component.html',
  styleUrls: ['./admin-timings.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class AdminTimingsComponent implements OnInit {
  @Input() timings: BaseTimingViewmodel[];
  constructor() {}

  ngOnInit(): void {}

  // `startsAt` is the next real occurrence of the class as an absolute instant, so
  // rendering it without a `timeZone` shows it on the viewer's own clock. The stored
  // `time` is only a wall clock, so it falls back to the day the server recorded.
  getDay(timing: BaseTimingViewmodel) {
    if (!timing.startsAt) {
      return [
        'Sunday',
        'Monday',
        'Tuesday',
        'Wednesday',
        'Thursday',
        'Friday',
        'Saturday',
      ][timing.day];
    }
    return new Date(timing.startsAt).toLocaleDateString('en-US', {
      weekday: 'long',
    });
  }

  getTime(timing: BaseTimingViewmodel) {
    const date = new Date(timing.startsAt ?? timing.time);
    if (!timing.startsAt) {
      return `${String(date.getUTCHours()).padStart(2, '0')}:${String(date.getUTCMinutes()).padStart(2, '0')}`;
    }
    return date.toLocaleTimeString('en-US', {
      hour: '2-digit',
      minute: '2-digit',
    });
  }

  getClassNumbers() {
    return [...new Set([...this.timings.map((s) => s.classNumber)])].sort(
      (a, b) => a - b,
    );
  }

  filterTiming(classNumber: number) {
    return this.timings.filter((s) => s.classNumber === classNumber);
  }
}
